// extracted by mini-css-extract-plugin
export default {"input":"textinput_input__Kmx6g"};